import React from 'react';
import PropTypes from 'prop-types';
import ProfileNavigation from './ProfileNavigation';

class Navigation extends React.Component {
  constructor(props, context) {
    super(props, context);
  }

  render() {
    const team = this.props.team;

    return <div>{team && <ProfileNavigation tabs={this.props.tabs} level={1} paths={this.props.paths} />}</div>;
  }
}

Navigation.propTypes = {
  paths: PropTypes.object.isRequired,
  history: PropTypes.object,
  team: PropTypes.object.isRequired
};

export default Navigation;
